import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { CargoSpace, RotateOptions } from 'src/app/core/types';
import { FormDataType } from '../../add-load.component';

@Component({
    selector: 'gl-load-rotate',
    templateUrl: './load-rotate.component.html',
    styleUrls: ['./load-rotate.component.scss'],
    standalone: false
})
export class LoadRotateComponent implements OnInit, OnChanges {
  public rotateOnBase = null;
  public rotateFreely = null;
  public allowToRotate = null;
  public allowOutOfSpace: boolean;
  @Output() public rotateOptions = new EventEmitter<RotateOptions>();
  @Output() public allowOutOfSpaceOption = new EventEmitter<boolean>();
  @Input() public savedRotateOptions: RotateOptions;
  @Input() public savedallowOutOfSpace: boolean;
  @Input() public loadData: FormDataType;
  @Input() public currentCargoSpace: CargoSpace[];

  public ngOnInit(): void {
    // Hydration is handled in ngOnChanges without emitting — emitting here would
    // re-fire on every tab remount (@if) and look like a user rotation change.
    this.allowOutOfSpace = this.savedallowOutOfSpace;
  }

  public onSubmit(): void {
    const formValue = {
      rotateOnBase: this.rotateOnBase,
      rotateFreely: this.rotateFreely,
      allowToRotate: this.allowToRotate === true ? false : this.allowToRotate,
      allowOutOfSpace: this.allowOutOfSpace,
    };
    this.rotateOptions.emit(formValue);
    this.allowOutOfSpaceOption.emit(this.allowOutOfSpace);
  }

  private resetRotateOptions(): void {
    this.rotateOnBase = null;
    this.rotateFreely = null;
    this.allowToRotate = null;
  }

  public onRotateChange(rotate: 'rotateFreely' | 'rotateOnBase' | 'allowToRotate'): void {
    this.rotateFreely = rotate === 'rotateFreely' ? true : null;
    this.allowToRotate = rotate === 'allowToRotate' ? true : null;
    this.rotateOnBase = rotate === 'rotateOnBase' ? true : null;
    this.onSubmit();
  }

  public onAllowOutOfSpaceChange(): void {
    this.allowOutOfSpace = !this.allowOutOfSpace;
    this.onSubmit();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.savedallowOutOfSpace && changes.savedallowOutOfSpace.currentValue) {
      this.allowOutOfSpace = changes.savedallowOutOfSpace.currentValue;
    }
    if (changes.savedRotateOptions && changes.savedRotateOptions.currentValue) {
      this.resetRotateOptions();
      const rotateOnBase = changes.savedRotateOptions.currentValue.rotateOnBase === undefined ? null : changes.savedRotateOptions.currentValue.rotateOnBase;
      const rotateFreely = changes.savedRotateOptions.currentValue.rotateFreely === undefined ? null : changes.savedRotateOptions.currentValue.rotateFreely;
      const allowToRotate = changes.savedRotateOptions.currentValue.allowToRotate === undefined ? null : changes.savedRotateOptions.currentValue.allowToRotate;
      const isAllNull: boolean =
        rotateOnBase === null && rotateFreely === null && allowToRotate === null;
      this.rotateOnBase = isAllNull ? true : rotateOnBase;
      this.rotateFreely = rotateFreely;
      this.allowToRotate = !isAllNull
        ? allowToRotate === false
          ? !allowToRotate
          : allowToRotate
        : null;
    }
  }
}
